"use client"

import * as React from "react"
import ContentPageLayout from "../../components/ContentPageLayout"
import CommunityContentLayout from "../../components/CommunityContentLayout"
import { StaticImage } from "gatsby-plugin-image"
import config from "../../config"
import firebase from "firebase"
import { navigate } from "gatsby"
import ContentCard from "../../components/content/contentCard.js"
import { firebaseInit } from "../../config"

const filterOptions = [
  { value: "7dias", label: "Semana" },
  { value: "mes", label: "Mes" },
]

const TrainingSummaryPage = ({ location }) => {
  const [formValues, setFormValues] = React.useState({
    id: "",
    nombre: "",
    avatar: "",
  })
  const [isPremium, setIsPremium] = React.useState(false)
  const [category, setCategory] = React.useState("")
  const [selectedFilter, setSelectedFilter] = React.useState("7dias")
  const [customDateRange, setCustomDateRange] = React.useState({
    dateFrom: "",
    dateTo: "",
  })
  const [showCustomDates, setShowCustomDates] = React.useState(false)
  const [summaryData, setSummaryData] = React.useState(null)
  const [error, setError] = React.useState("")
  const [loading, setLoading] = React.useState(false)
  const [userToken, setUserToken] = React.useState("")

  const periodLabel =
    selectedFilter === "7dias"
      ? "esta semana"
      : selectedFilter === "mes"
      ? "este mes"
      : ""

  // 1) Inicializar Firebase y obtener token
  React.useEffect(() => {
    firebaseInit(firebase)
    const unregister = firebase.auth().onAuthStateChanged(async user => {
      if (!user) {
        navigate("/")
        return
      }
      const token = await user.getIdToken(true)
      setUserToken(token)

      // Cargar datos de usuario una vez que tenemos email y token
      fetch(`${config.serverUri}/users?email=${user.email}`, {
        headers: {
          "x-sc-signature": token,
        },
      })
        .then(res => (res.ok ? res.json() : Promise.reject(res.status)))
        .then(data => {
          const acct = data[0]
          setFormValues({
            id: acct.id,
            nombre: acct.nombre,
            avatar: acct.avatar?.startsWith("http")
              ? acct.avatar
              : acct.avatar
              ? `${config.serverUri}${acct.avatar}`
              : "",
          })
          setIsPremium(acct.suscription === "premium")
          setCategory(
            acct.predominantCategory === "ninguna"
              ? "Usuario Shift"
              : acct.predominantCategory
          )
        })
        .catch(() => navigate("/"))
    })

    return () => unregister()
  }, [])

  // 2) Cargar datos de resumen cuando cambia el filtro o el usuario
  React.useEffect(() => {
    if (formValues.id && userToken) {
      fetchSummaryData()
    }
  }, [formValues.id, selectedFilter, customDateRange, userToken])

  const fetchSummaryData = () => {
    setLoading(true)
    setError("")

    let endpoint = `${config.serverUri}/user-summary?userId=${formValues.id}&filter=${selectedFilter}`

    if (
      selectedFilter === "personalizado" &&
      customDateRange.dateFrom &&
      customDateRange.dateTo
    ) {
      endpoint += `&dateFrom=${customDateRange.dateFrom}&dateTo=${customDateRange.dateTo}`
    }

    fetch(endpoint, {
      headers: {
        "x-sc-signature": userToken || "",
      },
    })
      .then(res => (res.ok ? res.json() : Promise.reject(res.status)))
      .then(data => {
        setSummaryData(data)
        setLoading(false)
      })
      .catch(err => {
        console.error("Error al cargar resumen:", err)
        setError("No se pudo cargar el resumen de entrenamiento")
        setLoading(false)
      })
  }

  const getMotivationalMessage = () => {
    if (!summaryData) return ""
    const stats = summaryData.estadisticas
    if (selectedFilter === "7dias") {
      const c = stats.currentWeekCount
      if (c <= 2) return "¡No te rindas! Un nuevo entrenamiento te espera."
      if (c <= 5) return "¡Buen trabajo! Mantén el ritmo."
      return "¡Increíble esfuerzo! Sigue así."
    }
    if (selectedFilter === "mes") {
      // asumo que el backend expone currentMonthCount; si no, sustituir por stats.totalCompleted
      const c = stats.currentWeekCount
      if (c <= 8) return "¡No te rindas! Un nuevo entrenamiento te espera."
      if (c <= 15) return "¡Buen trabajo! Mantén el ritmo."
      return "¡Increíble esfuerzo! Sigue así."
    }
    return ""
  }

  const handleFilterChange = e => {
    const value = e.target.value
    setSelectedFilter(value)
    setShowCustomDates(value === "personalizado")
  }

  const handleDateChange = e => {
    const { name, value } = e.target
    setCustomDateRange(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const renderRecommendations = () => {
    if (
      !summaryData ||
      !summaryData.recommendedBlock ||
      !summaryData.recommendedBlock.cards
    ) {
      return (
        <div className="text-center my-4">
          <p>No hay recomendaciones disponibles</p>
        </div>
      )
    }

    return (
      <div className="mt-4">
        <h3 style={{ color: "#00493C" }} className=" text-2xl font-bold mb-4">
          Recomendaciones
        </h3>
        <p className="mb-4 text-lg text-black">
          Completa tu entrenamiento con alguna de las siguientes sesiones
        </p>

        <div className="flex flex-wrap justify-between my-8">
          {summaryData.recommendedBlock.cards.map((card, key) => (
            <div
              className="sm:full p-2 overflow-auto
"
              key={key}
            >
              <ContentCard
                card={card}
                userHasSuscription={isPremium ? "premium" : "free"}
              />
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <>
      <ContentPageLayout location={location}>
        <div
          className="flex flex-col relative"
          style={{ height: 240, width: "100%" }}
        >
          <StaticImage
            alt="banner comunidad"
            src="../../images/banner_comunidad.png"
            objectFit="cover"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          <div className="absolute inset-x-0 top-24 text-center">
            {formValues.avatar && (
              <img
                src={formValues.avatar}
                alt="Avatar"
                className="w-20 h-20 rounded-full mx-auto mb-2 object-cover"
              />
            )}
            <h3 className="text-white text-xl">{formValues.nombre}</h3>
            <h2 className="text-white">{category}</h2>
          </div>
        </div>

        <CommunityContentLayout
          avatar={formValues.avatar}
          isPremium={isPremium}
        >
          <div className="font-sans">
            <h2 className="mb-4">Resumen de entrenamiento</h2>

            <div className="mb-4">
              <label
                htmlFor="filter"
                className="block text-sm font-medium mb-1"
              >
                Ver por:
              </label>
              <div className="relative">
                <select
                  id="filter"
                  value={selectedFilter}
                  onChange={handleFilterChange}
                  className="block w-full border border-gray-300 rounded-md py-2 px-3 bg-white focus:outline-none focus:ring-primary focus:border-primary"
                >
                  {filterOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {showCustomDates && (
              <div className="mb-4 grid grid-cols-2 gap-4">
                <div>
                  <label
                    htmlFor="dateFrom"
                    className="block text-sm font-medium mb-1"
                  >
                    Desde:
                  </label>
                  <input
                    type="date"
                    id="dateFrom"
                    name="dateFrom"
                    value={customDateRange.dateFrom}
                    onChange={handleDateChange}
                    className="block w-full border border-gray-300 rounded-md py-2 px-3"
                  />
                </div>
                <div>
                  <label
                    htmlFor="dateTo"
                    className="block text-sm font-medium mb-1"
                  >
                    Hasta:
                  </label>
                  <input
                    type="date"
                    id="dateTo"
                    name="dateTo"
                    value={customDateRange.dateTo}
                    onChange={handleDateChange}
                    className="block w-full border border-gray-300 rounded-md py-2 px-3"
                  />
                </div>
              </div>
            )}

            {summaryData && (
              <>
                <p className="mb-1 text-center text-lg font-bold">
                  {formValues.nombre} ¡Entrenaste{" "}
                  {summaryData.estadisticas.currentWeekCount} veces{" "}
                  {periodLabel}!
                </p>

                <p className="text-center text-lg mb-4">
                  {getMotivationalMessage()}
                </p>
              </>
            )}

            {loading ? (
              <div className="text-center my-8">Cargando...</div>
            ) : error ? (
              <div className="text-center my-8 text-red-500">{error}</div>
            ) : summaryData ? (
              <>
                <h3
                  style={{ color: "#00493C" }}
                  className=" text-2xl font-bold mb-4"
                >
                  Estadísticas
                </h3>
                <div className="bg-black text-green-400 rounded-lg p-4 mb-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <h4 className="text-white font-bold">
                        Entrenamientos completados
                      </h4>
                      <p className="  text-green-400">
                        {summaryData.estadisticas.totalCompleted} entrenamientos
                      </p>
                    </div>

                    <div>
                      <h4 className="text-white font-bold">Duración total</h4>
                      <p className="  text-green-400">
                        {(summaryData.estadisticas.totalDuration / 60).toFixed(
                          2
                        )}{" "}
                        minutos
                      </p>
                    </div>
                  </div>

                  <div className="mt-4">
                    <h4 className="text-white font-bold">
                      Clasificación del usuario
                    </h4>
                    <p className="uppercase text-green-400">
                      {summaryData.estadisticas.classification || "Ninguna"}
                    </p>
                  </div>
                </div>

                {renderRecommendations()}
              </>
            ) : (
              <div className="text-center my-8">
                <p>No hay datos disponibles para el período seleccionado.</p>
              </div>
            )}
          </div>
        </CommunityContentLayout>
      </ContentPageLayout>
    </>
  )
}
export default TrainingSummaryPage
